import type FinancialRecord from './FinancialRecord'
import type { FinancialTreeNode } from './FinancialTreeNode'

const flattenFinRecordTree = (
  tree: FinancialTreeNode | null
): FinancialRecord[] => {
  if (!tree) return []
  const record = tree.financialRecord as FinancialRecord
  const childRecords = tree.children.flatMap(c => flattenFinRecordTree(c))
  return [record, ...childRecords]
}

export default flattenFinRecordTree
